var map = {
	"./PropertyTaxPay/additionalRebate": "./src/config/forms/specs/PropertyTaxPay/additionalRebate.js",
	"./PropertyTaxPay/additionalRebate.js": "./src/config/forms/specs/PropertyTaxPay/additionalRebate.js",
	"./PropertyTaxPay/cardInfo": "./src/config/forms/specs/PropertyTaxPay/cardInfo.js",
	"./PropertyTaxPay/cardInfo.js": "./src/config/forms/specs/PropertyTaxPay/cardInfo.js",
	"./PropertyTaxPay/cashInfo": "./src/config/forms/specs/PropertyTaxPay/cashInfo.js",
	"./PropertyTaxPay/cashInfo.js": "./src/config/forms/specs/PropertyTaxPay/cashInfo.js",
	"./PropertyTaxPay/chequeInfo": "./src/config/forms/specs/PropertyTaxPay/chequeInfo.js",
	"./PropertyTaxPay/chequeInfo.js": "./src/config/forms/specs/PropertyTaxPay/chequeInfo.js",
	"./PropertyTaxPay/demandInfo": "./src/config/forms/specs/PropertyTaxPay/demandInfo.js",
	"./PropertyTaxPay/demandInfo.js": "./src/config/forms/specs/PropertyTaxPay/demandInfo.js",
	"./PropertyTaxPay/ownerInfo": "./src/config/forms/specs/PropertyTaxPay/ownerInfo.js",
	"./PropertyTaxPay/ownerInfo.js": "./src/config/forms/specs/PropertyTaxPay/ownerInfo.js",
	"./PropertyTaxPay/propertyAddress": "./src/config/forms/specs/PropertyTaxPay/propertyAddress.js",
	"./PropertyTaxPay/propertyAddress.js": "./src/config/forms/specs/PropertyTaxPay/propertyAddress.js",
	"./PropertyTaxPay/propertyInformation": "./src/config/forms/specs/PropertyTaxPay/propertyInformation.js",
	"./PropertyTaxPay/propertyInformation.js": "./src/config/forms/specs/PropertyTaxPay/propertyInformation.js",
	"./PropertyTaxPay/receiptInfo": "./src/config/forms/specs/PropertyTaxPay/receiptInfo.js",
	"./PropertyTaxPay/receiptInfo.js": "./src/config/forms/specs/PropertyTaxPay/receiptInfo.js",
	"./basicInformation": "./src/config/forms/specs/basicInformation.js",
	"./basicInformation.js": "./src/config/forms/specs/basicInformation.js",
	"./employeeChangePassword": "./src/config/forms/specs/employeeChangePassword.js",
	"./employeeChangePassword.js": "./src/config/forms/specs/employeeChangePassword.js",
	"./employeeForgotPasswd": "./src/config/forms/specs/employeeForgotPasswd.js",
	"./employeeForgotPasswd.js": "./src/config/forms/specs/employeeForgotPasswd.js",
	"./employeeLogin": "./src/config/forms/specs/employeeLogin.js",
	"./employeeLogin.js": "./src/config/forms/specs/employeeLogin.js",
	"./employeeOTP": "./src/config/forms/specs/employeeOTP.js",
	"./employeeOTP.js": "./src/config/forms/specs/employeeOTP.js",
	"./login": "./src/config/forms/specs/login.js",
	"./login.js": "./src/config/forms/specs/login.js",
	"./otp": "./src/config/forms/specs/otp.js",
	"./otp.js": "./src/config/forms/specs/otp.js",
	"./paymentModes": "./src/config/forms/specs/paymentModes.js",
	"./paymentModes.js": "./src/config/forms/specs/paymentModes.js",
	"./profile": "./src/config/forms/specs/profile.js",
	"./profile.js": "./src/config/forms/specs/profile.js",
	"./profileEmployee": "./src/config/forms/specs/profileEmployee.js",
	"./profileEmployee.js": "./src/config/forms/specs/profileEmployee.js",
	"./propertyTaxAssessment": "./src/config/forms/specs/propertyTaxAssessment.js",
	"./propertyTaxAssessment.js": "./src/config/forms/specs/propertyTaxAssessment.js",
	"./register": "./src/config/forms/specs/register.js",
	"./register.js": "./src/config/forms/specs/register.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/config/forms/specs recursive ^\\.\\/.*$";


//////////////////
// WEBPACK FOOTER
// ./src/config/forms/specs ^\.\/.*$
// module id = ./src/config/forms/specs recursive ^\.\/.*$
// module chunks = 504